import React, { useContext, useState, useEffect } from 'react';
import '../../App.css'
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';
import InputMask from 'react-input-mask';
import { useLocation } from 'react-router-dom';


const EditarEmpresa = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const location = useLocation()

  const empresa = location.state.data

  const [emailOk, setEmailOk] = useState(false)
  const [success, setSuccess] = useState(true)

  const [nomeFantasia, setNomeFantasia] = useState(empresa.nomeFantasia)
  const [cnpj, setCnpj] = useState(empresa.cnpj)
  const [userAdministrador, setUserAdministrador] = useState(empresa.adminUser)
  const [nomeAdministrador, setNomeAdministrador] = useState('')
  const dataCriacao = empresa.dataCriacao
  const [adminOk, setAdminOk] = useState(false)
  const [rua, setRua] = useState(empresa.rua)
  const [numero, setNumero] = useState(empresa.numero)
  const [compl, setCompl] = useState(empresa.compl)
  const [bairro, setBairro] = useState(empresa.bairro)
  const [cep, setCEP] = useState(empresa.cep)
  const [cidade, setCidade] = useState(empresa.cidade)
  const [uf, setUF] = useState(empresa.uf)
  const [telefone, setTelefone] = useState(empresa.telefone)
  const [conclusao, setConclusao] = useState(false)
  const [accessId, setAccesId] = useState()
  const password = "asadsda%4aksjd"

  useEffect(()=>{
    const randomId = Math.floor(Math.random() * 9999)
    setAccesId(randomId)
  }, [])


  const data = {
	  "cnpj": cnpj,
    "nomeFantasia": nomeFantasia,
    "rua": rua, 
    "numero": numero, 
    "compl": compl, 
    "bairro": bairro, 
    "cidade": cidade, 
    "uf": uf, 
    "cep": cep,
    "telefone": telefone, 
    "adminUser": userAdministrador,
    "dataCriacao": dataCriacao
}

  const dataUser = {
    "username": userAdministrador,
    "name": nomeAdministrador,
    "role": 'admin',
    "accessId": accessId,
    "password": password,
    "companyId": cnpj
  }


  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};


  async function SaveEmpresa() {
    await api.post('company/editCompany/', data, headers).then(response => {
        setConclusao(true)
    }).catch(error => {
      setSystemData({...systemData, erro: error.message, typeError: 'warning'})
    })
  }

  
  return (
    <>
        <Layout breadcrumb='Dashboard / Empresas / Editar empresa' title={`Editar ${empresa.nomeFantasia}`}>
          <Typography>Preencha os campos abaixo para adicionar uma nova empresa:</Typography>
          {conclusao ? 
            <>
              <div style={styles.block}></div>
              <div style={styles.block}></div>
              <span style={{fontWeight: 600, fontSize: 14, color: '#ff6400'}}>Empresa {nomeFantasia} salva com sucesso!</span>
              <div style={styles.block}></div>
              <div style={styles.block}></div>
            </>
:
          
          <>
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setNomeFantasia(event.target.value)} value={nomeFantasia} label="Nome Fantasia" variant="outlined" style={styles.item} />
            
            <InputMask
                mask="99.999.999/9999-99"
                disabled
                value={cnpj}
                maskChar=" "
            >
                {() => <TextField label="CNPJ - este campo não pode ser alterado." variant="outlined" style={styles.itemMed} />}
            </InputMask>
            <div>
              <TextField  onChange={(event) => setRua(event.target.value)} value={rua} label="Logradouro" variant="outlined" style={styles.itemMed} />
              <TextField  onChange={(event) => setNumero(event.target.value)} value={numero} label="Num." variant="outlined" style={styles.itemPeq} />
              <TextField  onChange={(event) => setCompl(event.target.value)} value={compl} label="Compl." variant="outlined" style={styles.itemPeq} />
            </div>
            <div>
              <TextField  onChange={(event) => setBairro(event.target.value)} value={bairro} label="Bairro" variant="outlined" style={styles.itemMed} />
              
              <InputMask
                  mask="99999-999"
                  value={cep}
                  onChange={(event) => setCEP(event.target.value)}
                  disabled={false}
                  maskChar=" "
              >
                  {() => <TextField label="CEP" variant="outlined" style={styles.itemPeq} />}
              </InputMask>
              
              <InputMask
                  mask="(99) 99999-9999"
                  value={telefone}
                  onChange={(event) => setTelefone(event.target.value)}
                  disabled={false}
                  maskChar=" "
              >
                  {() => <TextField label="Telefone" variant="outlined" style={styles.itemPeq} />}
              </InputMask>
            </div>
            <div>
              <TextField  onChange={(event) => setCidade(event.target.value)} value={cidade} label="Cidade" variant="outlined" style={styles.itemMed} />
              <TextField  onChange={(event) => setUF(event.target.value)} value={uf} label="UF" variant="outlined" style={styles.itemPeq} />
            </div>
            
            {adminOk ? null :
              <div style={styles.block}>
                <Button variant="contained" color='secondary' className='boto' style={{color: '#ffffff'}} onClick={()=>{SaveEmpresa()}}>
                  Salvar empresa
                </Button>
              </div>
            }
            

            <div style={styles.block}></div>
            <div style={styles.block}></div>
            {/* adminOk ?
            <>
              <div style={styles.item}>Alterar usuário administrador?</div>
              <TextField  onChange={(event) => setUserAdministrador(event.target.value)} value={userAdministrador} label="E-mail do administrador" variant="outlined" style={styles.item} />
              <TextField  onChange={(event) => setNomeAdministrador(event.target.value)} value={nomeAdministrador} label="Nome do administrador" variant="outlined" style={styles.item} />
              {conclusao ? null :
              <div style={styles.block}>
                <Button variant="contained" className='boto' style={{color: '#ffffff'}} onClick={()=>{ValidateEmail()}}>
                  Salvar e finalizar
                </Button>
              </div>
              }
            </>
            : null */}
          </>
}          
        </Layout>
    </>
  );
};

export default EditarEmpresa


const styles = {
  block: {
    marginTop: 10,
  },
    item: {
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    itemPeq: {
        width: 100,
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    itemMed: {
        width: 400,
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    }
}
